// This object is a direct translation of the values from your
// _themes-vars.module.scss file. It serves as the single source
// of truth for all post-login theme colors.

const colors = {
    // Paper
    paper: '#ffffff',

    // Primary
    primaryLight: '#ede7f6',
    primaryMain: '#5931c2',
    primaryDark: '#5e35b1',
    primary200: '#b39ddb',
    primary800: '#4527a0',

    // Secondary
    secondaryLight: '#e3f2fd',
    secondaryMain: '#2196f3',
    secondaryDark: '#1e88e5',
    secondary200: '#90caf9',
    secondary800: '#1565c0',

    // Success
    successLight: '#b9f6ca',
    success200: '#6fbf73',
    successMain: '#4caf50',
    successDark: '#357a38',

    // Error
    errorLight: '#ef9a9a',
    errorMain: '#f44336',
    errorDark: '#c62828',

    // Orange
    orangeLight: '#fbe9e7',
    orangeMain: '#ffab91',
    orangeDark: '#d84315',

    // Warning
    warningLight: '#fff8e1',
    warningMain: '#ffe57f',
    warningDark: '#ffc107',

    // Grey
    grey50: '#fafafa',
    grey100: '#f5f5f5',
    grey200: '#eeeeee',
    grey300: '#e0e0e0',
    grey500: '#9e9e9e',
    grey600: '#757575',
    grey700: '#616161',
    grey900: '#212121',

    // Brown
    brown50: '#efebe9',
    brown100: '#d7ccc8',
    brown200: '#bcaaa4',
    brown300: '#a1887f',
    brown500: '#795548',
    brown600: '#6d4c41',
    brown700: '#5d4037',
    brown900: '#3e2723',
    brownLight: '#70656d',
    brownMain: '#3c2116',
    brownDark: '#1c0000',
};

export default colors;

